<template>
  <div>
    <Sorting
      v-model="defaultParams.order_by"
      :defaultSelected="defaultParams.order_by"
    />
    <AuctionCard v-for="item in items" :key="item.id" :item="item" />
    <p v-if="items.length == 0" class="mt-5 text-center text-muted">
      แล้วพบกันเร็วๆนี้
    </p>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters, mapActions } from "vuex";

import Sorting from "@/views/Main/Sorting.vue";
import AuctionCard from "@/components/card/auction.vue";

export default {
  name: "AuctionList",

  components: {
    Sorting,
    AuctionCard,
  },

  data() {
    return {
      items: [],
      defaultParams: {
        order_by: "earliest_start",
      },
    };
  },

  apollo: {
    $subscribe: {
      eventAdded: {
        query: gql`
          subscription {
            eventAdded {
              lot_id
              user_id
              event
              points
              event_id
              product_name
            }
          }
        `,
        result({ data }) {
          const { lot_id, user_id, event, points } = data.eventAdded;

          switch (event) {
            case "success_bid":
              const itemIndex = this.items.findIndex((i) => i.id === lot_id);

              if (itemIndex > -1) {
                this.items[itemIndex].bid_points = points;
              }
              break;

            default:
              break;
          }
        },
      },
    },
  },

  watch: {
    list(v) {
      this.items = v;
    },
    "defaultParams.order_by"(v) {
      localStorage.setItem("auction_order_by", v);
      this.fetchLot();
    },
  },

  computed: {
    ...mapGetters({
      list: `auction/list`,
    }),
  },

  beforeMount() {
    this.defaultParams.order_by =
      localStorage.getItem("auction_order_by") || "earliest_start";
  },

  methods: {
    ...mapActions({
      fetch: `auction/fetch`,
    }),

    async fetchLot() {
      try {
        await this.fetch();
      } catch (error) {
        console.error(error);
      }
    },
  },

  async created() {
    await this.fetchLot();
  },
};
</script>
